import BaseApi from '../BaseApi'

class FormApi extends BaseApi {
  sendEmail = email => this.sendQuery(this.queryTypes.POST, `/v1/send_contact`, { contact: email })
}

export default FormApi
